import React from 'react';
import { getNumberWithDelimeter } from '../../../../utils/helpers';
import colors from '../../../../scss/colors';
import classes from './TableBasicLabel.module.scss';

export default function TableBasicLabel({
  withForceBrake = '100%',
  notNumber = false,
  text = '',
  fontSize = '15px',
  fontWeight = '600',
  lineHeight = '19px',
  fontColor = colors.NAVY_BLUE,
  isTruncate = false,
  textAlign = 'center',
  padding = '0',
  isEdit = false
}) {
  return (
    <p
      className={isTruncate ? classes.truncate : undefined}
      style={{ fontSize, fontWeight, lineHeight, color: fontColor, width: withForceBrake, textAlign, padding }}
    >
      {Number.isNaN(text) || notNumber ? text : getNumberWithDelimeter(text, isEdit)}
    </p>
  );
}
